// Koli sayısı at the packing desk: one kargo etiketi per box. Many units on one label are fine when
// they share a box; fewer labels than units that leave in their own box means a box without one.
import { expectedParcels } from '@wms/domain';

interface Packed {
  readonly lines: readonly { readonly required: number; readonly shipsAsIs: boolean }[];
  readonly parcels: number;
}

export interface LabelCheck {
  /** short: fewer labels than the boxes the goods need; single: 2+ units on one label */
  readonly kind: 'short' | 'single';
  readonly units: number;
  readonly needed: number;
  readonly ownBoxes: number;
}

/** What the desk asks after packing, or null when the labels cannot leave a box without one. */
export function labelCheck(order: Packed): LabelCheck | null {
  const units = order.lines.reduce((n, l) => n + l.required, 0);
  if (units < 2) return null;
  const needed = expectedParcels(order.lines);
  const ownBoxes = order.lines.reduce((n, l) => n + (l.shipsAsIs ? l.required : 0), 0);
  if (order.parcels < needed) return { kind: 'short', units, needed, ownBoxes };
  if (order.parcels === 1) return { kind: 'single', units, needed, ownBoxes };
  return null;
}

/** "2 ürün kendi kutusunda, diğerleri 1 kolide: en az 3 koli" */
export function neededText(needed: number, ownBoxes: number): string {
  return needed > ownBoxes
    ? `${ownBoxes} ürün kendi kutusunda, diğerleri 1 kolide gider: en az ${needed} koli`
    : `${ownBoxes} ürün paketlemeden, kendi kutusunda gider: en az ${needed} koli`;
}
